import React, { Component } from 'react';
import about from "assets/img/about.png";
import $ from 'jquery';
import {FaCaretRight} from 'react-icons/fa';


const Faqlist = ({quest, ans}) => {
  return (
      <div className="faqList">
          <div className="quest">
              <div className="iconArrow">
                  <FaCaretRight/>
              </div>
              <div>
                  {quest}
              </div>
          </div>
          <div className="ans" dangerouslySetInnerHTML={{__html: ans}}>
          </div>
      </div>
  )
}
class Faq extends Component{
	constructor(props) {
        super(props);
        this.state = {
            isHovered: false,
        };
    }

    componentDidMount() {
        $(".faqList > .quest").click(function () {
            $(this).toggleClass("open");
            $(this).next(".ans").stop(true, true).slideToggle("fast");
        });

        $(window).resize(function () {
            setTimeout(function () {
                $("#how_it_works .banner").height($("#how_it_works .banner img").height());
            }, 300);
        });

        // var count = 10;
        $(window).scroll(function () {
            let a = $(this).scrollTop();
            a = a - (a / 5);
            $("#how_it_works .banner img").css({position: 'relative', top: a + 'px'});
        });
    }
 	render(){
  	return(
    	// <section className="section first_section not_home grey">
      //   <div className="section_title">
      //     <img src={about} alt="FAQs" />
      //     <h2 className="mt-20">Frequently Asked Questions</h2>
      //   </div>

      //   <div className="container">
      //     <div className="row">
      //       <div className="col-md-12">
      //         {/* <!-- Adjudicators Section --> */}
      //         <div className="faq-section">
      //           <h2>Adjudicators</h2>
      //           <div className="faq-item">
      //             <h3>How do I get started?</h3>
      //             <p>
      //               First, using this app is VERY EASY. We recommend you watch the short introductory video. Press the red play button on the home screen of the app. It is only a minute and a half long.
      //             </p>
      //             <p>
      //               <strong>Login:</strong> Press the green button that says Adjudicator. You will receive your login code from your festival director (the code is NOT case-sensitive). Enter the code with your first and last name. Press Sign-In.
      //             </p>
      //             <p>
      //               <strong>Allow Permissions:</strong> If you do not, you will need to go to your app settings in your device and change them to Allow using your device’s microphone.
      //             </p>
      //             <p>
      //               We strongly recommend you put your phone ringer on “silent” or “do not disturb” so you do not get calls while you are adjudicating groups!
      //             </p>
      //             <p>
      //               <strong>IMPORTANT: Login BEFORE you come to the event!</strong> This will pre-load the list of groups you will be adjudicating. Some venues do not have an Internet connection and/or you cannot receive a cell signal. You will be able to record your commentary during the event even if there is not a connection there. As soon as your phone gets an Internet connection, your comments will immediately be uploaded for the director to hear.
      //             </p>
      //           </div>
      //           <div className="faq-item">
      //             <h3>How to I make and send a comment?</h3>
      //             <p>
      //             First, select the group you are going to be adjudicating. The app will ask you to “Allow Music Adjudicator to record audio?” Select “ALLOW WHILE USING THE APP” (you will only need to do this one time). When you are ready, press the 'Record' button at the bottom of the screen. You will see a recording screen pop up. Press the SEND icon when you are finished (looks like a paper airplane). It will confirm that your commentary was sent.
      //             </p>
      //           </div>
      //         </div>

      //         {/* <!-- Directors Section --> */}
      //         <div className="faq-section">
      //           <h2>Directors</h2>
      //           <div className="faq-item">
      //             <h3>When will I be able to listen to the Adjudicator’s commentaries?</h3>
      //             <p>
      //               As soon as they are finished with making their commentary and have uploaded it, you will have immediate access. You will need an Internet connection on your device to do this.
      //             </p>
      //           </div>
      //           <div className="faq-item">
      //             <h3>How do I hear the Adjudicator’s commentary?</h3>
      //             <p>
      //               You should have received a login code from your festival director. Select the button on the app that says ‘Music Director’. Enter the login code. You will see the judge’s commentaries. Select one of the commentaries, and you will see how to hear the comments on the next screen. Press the red play button and you will be able to listen to them.
      //             </p>
      //           </div>
      //         </div>
      //       </div>
      //     </div>
      //   </div>

      // </section>
	  <div>
      			<section className="faqs">
                    <div className="wordpressHeading text-center">FREQUENTLY ASKED QUESTIONS</div>
                    <div className="wordpressHeading text-center">Adjudicators</div>
					<div className="container">
						<div className="row">
							<div className="col-md-8 col-md-offset-2">
                                <Faqlist
                                    quest="How do I get started?"
                                    ans='First, using this app is VERY EASY. We recommend you watch the short introductory video. Press the red play button on the home screen of the app. Is only a minute and a half long. Login: Press the green button that says Adjudicator. You will receive your login code from your festival director (the code is NOT case-sensitive). Enter the code with your first and last name. Press Sign-In. <strong>Allow Permissions</strong> – If you do not, you will need to go to your app settings in your device and change them to Allow using your device’s microphone.
									<br />
									We strongly recommend you put your phone ringer on “silent” or “do not disturb” so you do not get calls while you are adjudicating groups!
									<br />
									<strong>IMPORTANT: Login BEFORE you come to the event!</strong> This will pre-load the list of groups you will be adjudicating. Some venues do not have an Internet connection and/or you cannot receive a cell signal. You will be able to record your commentary during the event even if there is not a connection there. As soon as your phone gets an Internet connection, your comments will immediately be uploaded for the director to hear.'
                                />

                                <Faqlist
                                    quest="How to I make and send a comment? "
                                    ans='First, select the group you are going to be adjudicating. The app will ask you to “Allow Music Adjudicator to record audio?” Select “ALLOW WHILE USING THE APP” (you will only need to do this one time). When you are ready, press the ‘Record’ button at the bottom of the screen. You will see a recording screen pop up. Press the SEND icon when you are finished (looks like a paper airplane). It will confirm that your commentary was sent.'
                                />

                                <Faqlist
                                    quest="Can I try it out before I go to the event to familiarize myself with it?"
                                    ans='Yes, if you want to try it out before the event starts, you CAN delete a testing comment (see the next FAQ below).'
                                />

                                <Faqlist
                                    quest="How do I delete a comment?"
                                    ans='On iPhone, you swipe your recording to the left, then select the red delete button. On Android, you will see a red X or a trashcan icon. The app will ask if you are sure you want to delete it.'
                                />

                                <Faqlist
                                    quest="Can I make more than one commentary for a group?"
                                    ans='Yes. Just press the record button again and leave your comments, then press SEND.'
                                />

                                <Faqlist
                                    quest="I accidentally selected the wrong group when giving my commentary, what should I do?"
                                    ans='Let your festival director know, and they will be able to get it fixed so the correct director receives your comments about their groups.'
                                />

                                <Faqlist
                                    quest="The app froze, what do I do?"
                                    ans='If this happens, first try to restart your device. This is a rare occurrence, but restarting usually will fix this. If it does not, do this: iPhones – delete the app and reinstall it, then login like you did before. Androids – from the top of your screen, swipe down. Press on the gear icon which will take you to your phone Settings. Select Apps. Find the “Music Adjudicator” app. Press “Storage”. Select “Clear Cache” and then “Clear Data”. Delete the app, reinstall it, and re-enter your login code and name. If this does not fix it, there is a memory problem with your device. The best solution is to delete some things from your phone, but you probably will not have time to do all of this. Ask your festival director to use a backup phone they may have at the event to use.'
                                />

                                <Faqlist
                                    quest="My commentary did not send, what do I do?"
                                    ans='On very rare occasions, a red ! mark will appear indicating your commentary did not send. For iPhone users, immediately delete and reinstall the app, that should fix it. For Android users, follow the directions above by clearing the cache and reinstalling the app. If this does not fix it, let your festival director know who will contact us to troubleshoot.'
                                />
                            </div>
                        </div>
                    </div>
                </section>

      			<section className="faqs">
                    <div className="wordpressHeading text-center">Directors</div>
					<div className="container">
						<div className="row">
							<div className="col-md-8 col-md-offset-2">
                                <Faqlist
                                    quest="When will I be able to listen to the Adjudicator’s commentaries?"
                                    ans='As soon as they are finished with making their commentary and have uploaded it, you will have immediate access. You will need an Internet connection on your device to do this.'
                                />

                                <Faqlist
                                    quest="How do I hear the Adjudicator’s commentary?"
                                    ans='You should have received a login code from your festival director. Select the button on the app that says ‘Music Director’. Enter the login code. You will see the judge’s commentaries. Select one of the commentaries, and you will see how to hear the comments on the next screen. Press the red play button and you will be able to listen to them.'
                                />

                                <Faqlist
                                    quest="Can I save the commentaries?"
                                    ans='Yes, you can do these one of two ways. First, with the app. You will see a ‘download’ icon beside the judge’s commentary. The app will tell you where it is located on your device, so be on the lookout for that.  To save it to your computer, go to musicadjudicator.com. Look at the top right side of the website and select ‘Music Director Login’. Once there, scroll down and you will see where to listen to and download the commentary onto your computer. Please note where it is downloaded so you can find it on your computer later.'
                                />

                                <Faqlist
                                    quest="How can I share the commentary with my students?"
                                    ans='The easiest way is to give them your login code. They can access it through the app or the website like you can. Or, if you download the audio file commentaries you can email them to your students.'
                                />

                                <Faqlist
                                    quest="My festival recorded our performance. Is this available on the app or website?"
                                    ans='Sometimes they will provide you with this recording with a physical device like a USB drive. If they added the recording to our system, you could hear it – and download it – from the musicadjudicator.com website. After you login to the website with your login code, you will see a tab that says ‘Festivals Recordings’ beside the tab that says ‘Adjudicator Comments’. If YOU have a recording that you did yourself, you can add this on the website as well. You will see a button that says ‘+ Add Festival Recording’.'
                                />
                            </div>
                        </div>
                    </div>
                </section>
	  </div>
  	);
  }
}
export default Faq;


// WEBPACK FOOTER //
// ./src/components/FrontEnd/Faq.jsx